<footer class="footer">
  <div class="footer-content justify-content-between">
    <p class="m-b-0">Copyright © {{ year }} Evolved Experience Solutions, Inc.</p>
    <span>
      <a href="" class="text-gray m-r-15" [routerLink]="['/terms-of-service']">Term &amp; Conditions</a>
      <a href="" class="text-gray" [routerLink]="['/privacy-policy']">Privacy Notice</a>
    </span>
  </div>
</footer>
